<template>
  <div class="wizard-page">
    <div class="page-container container-fluid">

      <div class="wizard-card mx-auto">

        <div class="page-header text-center">
          <img src="../../assets/image/dharma2.png" alt="Kementerian Perhubungan" class="header-logo" />

          <h2>Konfirmasi Pelanggaran Kendaraan</h2>
          <p>Direktorat Jenderal Perhubungan Darat</p>
        </div>

        <div class="step-nav">

          <div class="step-item" :class="{ active: currentStep === 1, done: currentStep > 1 }">
            <span>1</span>
            <label>Cari Data</label>
          </div>

          <div class="step-item" :class="{ active: currentStep === 2, done: currentStep > 2 }">
            <span>2</span>
            <label>Detail Pelanggaran</label>
          </div>

          <div class="step-item" :class="{ active: currentStep === 3, done: currentStep > 3 }">
            <span>3</span>
            <label>Konfirmasi & Sanggahan</label>
          </div>

          <div class="step-item" :class="{ active: currentStep === 4 }">
            <span>4</span>
            <label>{{ milik === 3 ? 'Pelapor' : 'Pengemudi' }}</label>
          </div>

        </div>

        <transition name="step-fade" mode="out-in">
          <Step1 v-if="currentStep === 1" @next="handleNextStep" />

          <Step2 v-else-if="currentStep === 2" :noReferensi="noReferensi" :noPolisi="noPolisi"
            :pelanggaranData="pelanggaranData" @prev="prevStep" @next="handleNextStep" />

          <Step3 v-if="currentStep === 3" :noReferensi="noReferensi" :noPolisi="noPolisi"
            :pelanggaranData="pelanggaranData" :step3Data="step3Data" @save-step3="saveStep3" @prev="prevStep"
            @next="handleNextStep" />

          <Step4 v-else-if="currentStep === 4 && milik !== null" :noReferensi="noReferensi" :noPolisi="noPolisi"
            :milik="milik" :confirmationType="step4Data.confirmation_type" :status="step4Data.status"
            :alasan="step4Data.alasan" :idTipeSanggahan="step4Data.idTipeSanggahan"
            :namaTipeSanggahan="step4Data.namaTipeSanggahan" :uploadBukti="step4Data.uploadBukti"
            :step4Data="step4FormData" @save="saveStep4" @prev="prevStep" />

        </transition>

      </div>

    </div>
  </div>
</template>

<script>
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
import Step4 from "./Step4.vue";

export default {
  data() {
    return {
      currentStep: 1,
      noReferensi: "",
      noPolisi: "",
      pelanggaranData: null,
      milik: null,

      step3Data: {
        inginSanggah: null,
        idTipeSanggahan: null,
        alasan: "",
        dokumenFile: null
      },

      step4Data: {
        uploadBukti: null,
        alasan: "",
        status: "",
        idTipeSanggahan: null,
        namaTipeSanggahan: "",
        confirmation_type: null
      },

      step4FormData: {
        formData: null,
        pengemudi: true,
        simPreview: null,
        fotoPreview: null
      }
    };
  },
  methods: {

    saveStep3(data) {
      this.step3Data = { ...data };
    },

    saveStep4(data) {
      this.step4FormData = {
        ...data
      };
    },

    handleNextStep(data) {
      this.noReferensi = data.noReferensi || this.noReferensi;
      this.noPolisi = data.noPolisi || this.noPolisi;

      if (data.pelanggaranData) {
        this.pelanggaranData = data.pelanggaranData;
      }

      if (data.milik !== undefined) {
        this.milik = parseInt(data.milik, 10);
      }

      if (data.status !== undefined) {
        this.step4Data.status = data.status === "KONFIRMASI_BENAR" ? "TERKONFIRMASI" : data.status;
      }

      if (data.alasan !== undefined) {
        this.step4Data.alasan = data.alasan;
      }

      if (data.dokumenFile !== undefined) {
        this.step4Data.uploadBukti = data.dokumenFile;
      }

      this.step3Data = {
        ...this.step3Data,
        inginSanggah:
          data.inginSanggah !== undefined
            ? data.inginSanggah
            : this.step3Data.inginSanggah,

        idTipeSanggahan:
          data.idTipeSanggahan !== undefined
            ? data.idTipeSanggahan
            : this.step3Data.idTipeSanggahan,

        alasan:
          data.alasan !== undefined
            ? data.alasan
            : this.step3Data.alasan,

        dokumenFile:
          data.dokumenFile !== undefined
            ? data.dokumenFile
            : this.step3Data.dokumenFile,
      };

      if (data.idTipeSanggahan !== undefined) {
        this.step4Data.idTipeSanggahan = data.idTipeSanggahan;
      }

      if (data.namaTipeSanggahan !== undefined) {
        this.step4Data.namaTipeSanggahan = data.namaTipeSanggahan;
      }

      if (data.confirmation_type !== undefined) {
        this.step4Data.confirmation_type = data.confirmation_type;
      }

      this.nextStep();
    },
    nextStep() {
      if (this.currentStep < 4) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
  },
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
  },
};
</script>

<style scoped>
.page-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 24px;
}

.wizard-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f6f8fc 0%, #eef3fb 100%);
  font-size: 16px;
}

.wizard-card {
  background: #fff;
  border-radius: 20px;
  padding: 50px 60px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
  width: 100%;
  margin: 0 auto;
  border: 1px solid #cbd5e1;
}

.page-header {
  margin-bottom: 40px;
}

.page-header h2 {
  font-weight: normal;
  color: #0f2f5f;
  font-size: 34px;
  letter-spacing: -0.5px;
}

.page-header p {
  color: #2d3748;
  margin-top: 8px;
  font-size: 18px;
  font-weight: normal;
}

.step-nav {
  display: flex;
  justify-content: center;
  margin: 20px 0 45px;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.08);
  border: 1px solid #cbd5e1;
}

.step-item {
  flex: 1;
  position: relative;
  padding: 22px 24px;
  background: #f8fafc;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  font-weight: normal;
  font-size: 18px;
  transition: 0.25s ease;
}

.step-item span {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: normal;
  color: #0f2f5f;
  transition: 0.25s ease;
}

.step-item label {
  cursor: default;
  margin-bottom: 0;
}

.step-item.active {
  background: linear-gradient(135deg, #1e40af, #1d4ed8);
  color: #ffffff;
}

.step-item.active span {
  background: #ffffff;
  color: #1e40af;
}

.step-item.done {
  background: #15803d;
  color: #ffffff;
}

.step-item.done span {
  background: rgba(255, 255, 255, 0.3);
  color: #ffffff;
}

.step-fade-enter-active,
.step-fade-leave-active {
  transition: all 0.2s ease;
}

.step-fade-enter-from {
  opacity: 0;
  transform: translateY(4px);
}

.step-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.header-logo {
  width: 90px;
  height: 90px;
  object-fit: contain;
  margin-bottom: 18px;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.08));
}

@media (max-width: 992px) {
  .page-container {
    padding: 30px 16px;
  }

  .wizard-card {
    padding: 35px 24px;
  }

  .step-item {
    padding: 18px 10px;
    font-size: 15px;
    flex-direction: column;
    gap: 8px;
  }

  .step-item span {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
}
</style>